export default async function requestPermissions(permissionName) {
    if ( permissionName in navigator) {
        return await navigator.permissions.query({ name: permissionName });
    }
    throw new Error (`Acceso a ${permissionName} no disponible`);
}